import { devDebug } from "./devLog";
// Local per-tab store of muted DM conversations. Purely client-side: the
// server never knows which conversations you have silenced. Mute affects
// the browser notification behaviour only — messages themselves are still
// delivered/decrypted normally.
//
// Uses the zero-knowledge localStore wrapper — no sensitive data ever
// leaves the browser or is persisted here.

import { readItem, writeItem } from "./localStore";

const KEY = "ol_dm_muted_v1";

function readSet() {
  const raw = readItem(KEY);
  if (!raw) return new Set();
  try {
    const arr = JSON.parse(raw);
    return new Set(Array.isArray(arr) ? arr : []);
  } catch (err) {
    devDebug("dmMute: parse failed, resetting mute list", err?.message);
    return new Set();
  }
}

function writeSet(set) {
  writeItem(KEY, JSON.stringify([...set]));
}

export function isConversationMuted(conversationId) {
  if (!conversationId) return false;
  return readSet().has(conversationId);
}

export function toggleConversationMuted(conversationId) {
  if (!conversationId) return false;
  const set = readSet();
  if (set.has(conversationId)) set.delete(conversationId);
  else set.add(conversationId);
  writeSet(set);
  return set.has(conversationId);
}

export function listMutedConversations() {
  return [...readSet()];
}
